module.exports = __webpack_public_path__ + "static/img/Customised_Clothing_Headers-05.7925077.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2024/Customised_Clothing_Headers-05.png
// module id = oIDu
// module chunks = 1